import React from 'react'
import Scrollbar from 'react-smooth-scrollbar'
import classNames from 'classnames'
import { SidebarProps } from 'Shared/types/reducerTypes'
import SidebarContent from './components/SidebarContent'
import { Overlay } from './styles'

type SidebarComponentProps = {
  changeMobileSidebarVisibility: () => void
  sidebar: SidebarProps
}

const Sidebar: React.FunctionComponent<SidebarComponentProps> = ({
  changeMobileSidebarVisibility,
  sidebar,
}) => {
  const sidebarClass = classNames({
    sidebar: true,
    'sidebar--show': sidebar.show,
    'sidebar--collapse': sidebar.collapse,
    'sidebar--hidden': sidebar.hidden,
  })

  return (
    <Overlay>
      <div className={sidebarClass}>
        <button
          className="sidebar__back"
          type="button"
          onClick={changeMobileSidebarVisibility}
        />
        <Scrollbar className="sidebar__scroll scroll">
          <div className="sidebar__wrapper sidebar__wrapper--desktop">
            <SidebarContent collapse={sidebar.collapse} />
          </div>
          <div className="sidebar__wrapper sidebar__wrapper--mobile">
            <SidebarContent
              collapse={sidebar.collapse}
              onClick={changeMobileSidebarVisibility}
            />
          </div>
        </Scrollbar>
      </div>
    </Overlay>
  )
}

export default Sidebar
